import {safeGet} from "./utils";

const MINIMAL_PROPERTY_PATHS: string[] = [
  'devicePixelRatio',
  'navigator.connection.downlink',
  'navigator.connection.rtt',
  'location.href',
  'navigator.deviceMemory',
  'navigator.hardwareConcurrency',
  'navigator.language',
  'navigator.languages',
  'navigator.userAgent',
  'origin',
];

const STANDARD_PROPERTY_PATHS: string[] = [
  'navigator.connection.downlink',
  'navigator.connection.rtt',
  'devicePixelRatio',
  'history.length',
  'innerHeight',
  'innerWidth',
  'location.href',
  'locationbar.visible',
  'menubar.visible',
  'navigator.cookieEnabled',
  'navigator.deviceMemory',
  'navigator.hardwareConcurrency',
  'navigator.language',
  'navigator.languages',
  'navigator.maxTouchPoints',
  'navigator.pdfViewerEnabled',
  'navigator.platform',
  'navigator.userAgent',
  'navigator.webdriver',
  'origin',
  'outerHeight',
  'outerWidth',
  'personalbar.visible',
  'screen.availHeight',
  'screen.availWidth',
  'screen.colorDepth',
  'screen.height',
  'screen.orientation.angle',
  'screen.orientation.type',
  'screen.pixelDepth',
  'screen.width',
  'scrollbars.visible',
];

export function readWindowProperties(minimalDataMode: boolean): { [key: string]: any } {
  const paths = minimalDataMode ? MINIMAL_PROPERTY_PATHS : STANDARD_PROPERTY_PATHS;
  const result: { [key: string]: any } = {};
  for (const path of paths) {
    const fullPath = 'window.' + path;
    result[fullPath.replace(/\./g, '-')] = safeGet(() => readPath(fullPath));
  }
  return result;
}

function readPath(path: string): any {
  const parts = path.split('.');
  let current: any = window;
  for (const part of parts.slice(1)) {
    if (!current) return null;
    const methodMatch = part.match(/^(\w+)\(\)$/);
    if (methodMatch) {
      try {
        current = current[methodMatch[1]]();
      } catch {
        return null;
      }
    } else {
      current = current[part];
    }
  }
  return current;
}
